import {LogEnum} from "../Enums/LogEnum";

export default class MessageLogModel {
    text: string = null;
    type: LogEnum = null;
}